export default __webpack_public_path__ + "static/media/politica_privacidade_enfuroped.260f9308.pdf";